import "./Login.css"

const Login = () => {
  return (
    <div>Login</div>
  )
}

export default Login